import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { MenuPage } from '../menu/menu'
import { SlideContentPage } from '../slidecontent/slidecontent'
import { HttpClient } from '@angular/common/http';
import { AppConfigProvider } from '../../providers/app-config/app-config';
import { Storage } from '@ionic/storage';

/**
 * Generated class for the SearchPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-search',
  templateUrl: 'search.html',
})
export class SearchPage {
  keyword: String;
  // result: any[] = [];
  result_p: any[] = [];
  result_s: any[] = [];
  result_c: any[] = [];
  token: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private http: HttpClient,
    private appConfig: AppConfigProvider,
    private storage: Storage
  ) {
  }

  async ngOnInit() {
    this.token = await this.storage.get('token');
  }

  search() {
    // this.result = [];

    this.result_p = [];
    this.result_s = [];
    this.result_c = [];


    this.http
    .post(this.appConfig.apiUrl() + 'index.php/api/search/item', {
      token: this.token,
      keyword: this.keyword,
      app_key: this.appConfig.appKey()
    })
    .subscribe(
      (res: any) => {
        let data = res.result;

        if (data) {
          for (let result of data) {
            switch (result.type) {
              case 'portfolio':
                let temp_p = {
                  id: result.id,
                  title: result.name,
                  type: result.type,
                  background: result.feature_image,
                }

                this.result_p.push(temp_p);

                break;

              case 'subportfolio':
                let temp_s = {
                  id: result.id,
                  title: result.name,
                  type: result.type,
                  background: result.feature_image,
                }

                this.result_s.push(temp_s);

                break;

              case 'content':
                let temp_c = {
                  id: result.id,
                  title: result.name,
                  type: result.type,
                  background: result.feature_image,
                  content_id: result.content_id,
                  unique_id: result.unique_id,
                  description: result.description,
                }

                this.result_c.push(temp_c);
                break;

              default:
                break;
            }
          }
        } else {
          this.result_p = [];
          this.result_s = [];
          this.result_c = [];
        }
      },
      err => {
        console.log('Error request' + JSON.stringify(err));
      }
    );
  }

  openItem(item) {
    if (item.type == 'portfolio') {
      this.navCtrl.push(MenuPage, {
        portfolio_title: item.title,
        portfolio_id: item.id,
        header_img: item.background
      });
    }

    if (item.type == 'subportfolio') {
      this.navCtrl.push(SlideContentPage, {
        subportfolio_id: item.id,
        img: item.background,
        title: item.title
      });
    }

    if (item.type == 'content') {
      console.log(item);
      this.navCtrl.push(SlideContentPage, {
        subportfolio_id: item.id,
        img: 'http://salihin.noip.me/syariah-admin/index.php/readfile/index/' + item.unique_id,
        title: item.title,
        content_id: item.content_id,
        desc: item.description
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/search/search.ts